import { toast } from "react-toastify";
import ErrorUtils from "../../utils/ApiUtils/ErrorUtils";
import { useMutation } from "react-query";
import { translateLabel } from "../../api/translateLabel";
import { Label } from "../../model/Label"; // Import your Label type

interface UseTranslateLabelOptions {
  onSuccess?: (updatedLabel: Label) => void;
}

export function useTranslateLabel(options?: UseTranslateLabelOptions) {
  return useMutation({
    mutationFn: translateLabel,
    onSuccess: (response) => {
      toast.success("Translation saved");
      if (options?.onSuccess) {
        if (response) {
          options.onSuccess(response);
        }
      }
    },
    onError: (error) => {
      let errorMsg = ErrorUtils.getErrorMessage(error);
      toast.error(errorMsg);
      console.error("Error submitting form:", error);
    },
  });
}
